import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';
import type { Station, StationContextValue } from '@/types';

const initialValue: StationContextValue = {
  selectedStation: null,
  selectStation: () => {},
  isDrawerOpen: false,
  openDrawer: () => {},
  closeDrawer: () => {},
};

const StationContext = createContext<StationContextValue>(initialValue);

export function StationProvider({ children }: { children: ReactNode }) {
  const [selectedStation, setSelectedStation] = useState<Station | null>(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const selectStation = useCallback((station: Station | null) => {
    setSelectedStation(station);
    if (station) {
      setIsDrawerOpen(true);
    }
  }, []);

  const openDrawer = useCallback(() => {
    setIsDrawerOpen(true);
  }, []);

  const closeDrawer = useCallback(() => {
    setIsDrawerOpen(false);
  }, []);

  const value: StationContextValue = {
    selectedStation,
    selectStation,
    isDrawerOpen,
    openDrawer,
    closeDrawer,
  };

  return (
    <StationContext.Provider value={value}>
      {children}
    </StationContext.Provider>
  );
}

export function useStation(): StationContextValue {
  const context = useContext(StationContext);
  if (context === undefined) {
    throw new Error('useStation must be used within a StationProvider');
  }
  return context;
}
